import React from 'react';
import ReactDOM from 'react-dom';
import PCWorldClosure from './types/PCWorldClosure/PCWorldClosure.jsx';
import { getActiveMessage, disableMessageById } from './helpers/index.js';

export default function initPCWorldClosure() {
  const activePopupMessageData = getActiveMessage();
  const pageWrapper = document.querySelector('#page');
  const pcWorldClosureWrapper = document.createElement('div');

  if (activePopupMessageData && pageWrapper) {
    pcWorldClosureWrapper.setAttribute('id', 'PCWClosureWrapper');
    pageWrapper.appendChild(pcWorldClosureWrapper);
    ReactDOM.render(
      <PCWorldClosure cookieMessage={activePopupMessageData} />,
      pcWorldClosureWrapper,
      disableMessageById(activePopupMessageData.id)
    );
  }
}
